import { render } from "./AdminEstateOptionalUpgrades.vue?vue&type=template&id=0354d724&scoped=true&ts=true&lang=pug"
import script from "./AdminEstateOptionalUpgrades.vue?vue&type=script&lang=ts&setup=true"
export * from "./AdminEstateOptionalUpgrades.vue?vue&type=script&lang=ts&setup=true"

import "./AdminEstateOptionalUpgrades.vue?vue&type=style&index=0&id=0354d724&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0354d724"]])

export default __exports__